import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fed660c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "imgtxt_wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal_place_input_hint" }, "图片小于2M,支持JPG,PNG,GIF", -1))

import { ref, watch, unref } from 'vue';
import { message, Input } from 'ant-design-vue';
import { ImgTxt } from '../type';
import CUpload from '@/components/CUpload.vue';
interface IProps {
  modelValue: any;
}
export interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
}
export interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

const __default__ = { name: 'ModalCreateImgTxt' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: null
  },
  setup(__props: any) {

const props = __props as {
  modelValue: any;
};

const aTextarea = Input.TextArea;


const form = ref<ImgTxt>({
  msg_id: '',
  img: '',
  content: '',
  created_at: '',
});
form.value = unref(props.modelValue);
watch(
  () => props.modelValue,
  (newVal) => {
    form.value = newVal;
  }
);
// upload module
function getBase64(img: Blob, callback: (base64Url: string) => void) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(img);
}
const fileList = ref([]);
const loading = ref<boolean>(false);
const handleChange = (info: FileInfo): void => {
  if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  }
  if (info.file.status === 'done') {
    getBase64(info.file.originFileObj, (base64Url: string) => {
      if (info.file?.response?.code === 200) {
        form.value.img = info.file?.response?.data.url;
      } else {
        message.error(info.file?.response?.message);
      }
      loading.value = false;
    });
  }
  if (info.file.status === 'error') {
    loading.value = false;
    message.error('上传失败');
  }
};
const imageDel = () => {
  form.value.img = '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CUpload, {
        "file-list": fileList.value,
        "handle-change": (info) => handleChange(info),
        loading: loading.value,
        "image-name": form.value.img,
        "click-stop": imageDel,
        class: "ant_upload"
      }, null, 8, ["file-list", "handle-change", "loading", "image-name"]),
      _createVNode(_unref(aTextarea), {
        class: "c_textarea imgtxt_area",
        value: form.value.content,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.content) = $event))
      }, null, 8, ["value"])
    ]),
    _hoisted_2
  ]))
}
}

})